import { render, staticRenderFns } from "./ConfirmarContacto.vue?vue&type=template&id=6ae902a2&scoped=true&"
import script from "./ConfirmarContacto.vue?vue&type=script&lang=js&"
export * from "./ConfirmarContacto.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmarContacto.vue?vue&type=style&index=0&id=6ae902a2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae902a2",
  null
  
)

export default component.exports